import React, { useCallback } from 'react'

import { getRoutingPreviousLocation } from '@disco/state-management/selectors/routing'

import { useNavigate, useSearchParams } from 'react-router-dom'

import DocumentHeadTags from 'components/document-head-tags'

import { useSelector } from 'hooks/use-redux'
import RightsDataModal from 'components/modals/track/rights-modal'

const ThirdPartyRightsData = ():
  | React.ReactNode
  | React.ReactElement<'div'> => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const previousLocation = useSelector(getRoutingPreviousLocation)
  const returnTo = previousLocation

  const handleClose = useCallback(() => {
    if (returnTo) {
      navigate(returnTo)
    } else {
      navigate(-1)
    }
  }, [navigate, returnTo])

  return (
    <>
      <DocumentHeadTags title={`Rights Data | DISCO`} />
      <RightsDataModal
        handleClose={handleClose}
        isrc={searchParams.get('isrc') ?? undefined}
        title={searchParams.get('title') ?? undefined}
        artist={searchParams.get('artist') ?? undefined}
      />
    </>
  )
}

export default ThirdPartyRightsData
